export default "__VITE_ASSET__MA4OoBpA__"